import React, { useState } from 'react'
import TextField from '@mui/material/TextField'
import { Button, Card, Flex, Input, Spinner } from '../../Components'
import siapLogo from '../../Resources/crslinkLogo.png'
import { useAuth } from '../../Provider/AuthProvider'
import logoSiap from '../../Resources/logoSiap.png'

function Login () {
  const { onLogin } = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [waiting, setWaiting] = useState(false)

  const onClickLogin = async () => {
    if (!username || !password) {
      window.growl.show({ severity: 'warn', summary: 'Attenzione', detail: 'Compila tutti i campi' })
      return
    }
    setWaiting(true)
    await onLogin({ username, password })
    setWaiting(false)
  }

  return (
    <Flex fw fh>
      <Card style={{ width: '180', height: '140', padding: 50, borderRadius: 28, margin: '0 auto', position: 'static' }}>
        <Flex fw fh>
          <img src={siapLogo} style={{ width: 180 }} />
          <Flex fw fh style={{ gap: '1.4em', marginTop: '36px', marginBottom: '24px' }}>
            <TextField
              id='username'
              name='username'
              label='Username'
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && onClickLogin()}
              size='small'
              sx={{
                width: 300,
                '& .MuiOutlinedInput-root': {
                  borderRadius: '6px',
                  height: 42,
                  backgroundColor: '#FBFAF5'
                }
              }}
            />
            <Input
              password
              placeholder='Password'
              id='password'
              value={password}
              onChange={(e) => setPassword(e.password)}
              onEnter={onClickLogin}
            />
          </Flex>
          {waiting
            ? <Spinner />
            : <Button primary label='Accedi' icon='cloud-up' onClick={onClickLogin} style={{ marginBottom: 10, width: 300 }} />}
          <br />
          <img src={logoSiap} alt='Powered by SIAP' style={{ maxHeight: 46, position: 'relative', top: 20 }} />
        </Flex>
      </Card>
    </Flex>
  )
}

export default Login
